export default "__VITE_ASSET__XGfHNCh7__"